// extracted by mini-css-extract-plugin
export default {"placeholderDateText":"CardTabs_placeholderDateText__w2zqZ"};